import { Link } from "react-router-dom";
import { logo } from "../assets/icons";
import { useContext } from "react";
import { AppContext } from "../context/context";

function NavBar({ scroll }) {
  const { state, setState } = useContext(AppContext);

  return (
    <nav className="fixed z-20 top-0 left-0 right-0 w-full h-fit smd:px-4 smd:pt-4">
      <div className="w-full h-[54px] bg-teal smd:rounded-full flex justify-between gap-4 px-6 smd:px-8 md:px-12 lg:px-16 xl:px-24 shadow-xl md:shadow-[0px_5px_10px_5px_rgba(50,50,50,0.4)]">
        <div className="w-fit h-full flex items-center gap-3 lg:gap-10 xl:gap-14 text-white">
          <button
            onClick={() => scroll("home")}
            className="w-fit flex items-center gap-3 hover:text-black duration-500"
          >
            <div className="w-[180px]">{logo}</div>
          </button>

          <div className="w-fit h-full hidden md:flex items-center gap-4 md:gap-6 lg:gap-10 xl:gap-14">
            <button
              onClick={() => scroll("features")}
              className="hover:text-black duration-500"
            >
              Overview
            </button>
            <button
              onClick={() => scroll("details")}
              className="hover:text-black duration-500"
            >
              Features
            </button>
            <button
              onClick={() => scroll("pricing")}
              className="hover:text-black duration-500"
            >
              Pricing
            </button>
            <button
              onClick={() => scroll("contactus")}
              className="hover:text-black duration-500 whitespace-nowrap"
            >
              Contact Us
            </button>
          </div>
        </div>

        <div className="w-fit hidden md:flex items-center text-white gap-4 lg:gap-6">
          <Link
            to="/hrm/login"
            className="w-fit px-3 pb-0.5 flex justify-center items-center border-[2px] border-purp hover:border-purple-600 bg-purp hover:bg-purple-600 rounded-full duration-500"
          >
            Login
          </Link>
          <Link
            to="/hrm/signup"
            className="w-fit px-3 whitespace-nowrap pb-0.5 flex justify-center items-center border-[2px] border-purp hover:border-purple-600 bg-purp hover:bg-purple-600 rounded-full duration-500"
          >
            Sign Up
          </Link>
        </div>

        <div className="w-fit h-full flex md:hidden items-center ">
          <button
            className="flex flex-col h-fit w-12 rounded justify-center items-center group"
            onClick={() =>
              setState({ ...state, showDropdown: !state.showDropdown })
            }
          >
            <div
              className={`h-0.5 w-7 my-[3px] rounded-full bg-white transition duration-500 ${
                state.showDropdown
                  ? "rotate-45 translate-y-2 opacity-70 group-hover:opacity-100"
                  : "opacity-70 group-hover:opacity-100"
              }`}
            />
            <div
              className={`h-0.5 w-7 my-[3px] rounded-full bg-white transition duration-500 ${
                state.showDropdown
                  ? "opacity-0"
                  : "opacity-70 group-hover:opacity-100"
              }`}
            />
            <div
              className={`h-0.5 w-7 my-[3px] rounded-full bg-white transition duration-500 ${
                state.showDropdown
                  ? "-rotate-45 -translate-y-2 opacity-70 group-hover:opacity-100"
                  : "opacity-70 group-hover:opacity-100"
              }`}
            />
          </button>
        </div>
      </div>
    </nav>
  );
}

export default NavBar;
